import React from "react";
import { Controller, useForm } from "react-hook-form";
import { toastr } from "react-redux-toastr";
import { Customer, Phone } from "../../../../core/api/models";
import CustomerPhone from "../../../../components/customer-phone";
import api from "../../../../api";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import {
  CheckPhoneNumberEmpty,
  ValidatePhoneNumberArray,
} from "../../../../utils/Validatation";
import {
  UpdateCompanyData,
  Company,
} from "../../../../core/api/models/company";

const EditCompanyPhone: React.FunctionComponent<{
  error?: string;
  onClose: () => void;
  updateCompany: (details: Company) => void;
  details?: Company;
}> = (props) => {
  const { control, handleSubmit, errors } = useForm<Customer>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const onSubmit = async (data?: any) => {
    let isValid = true;
    data?.phones?.forEach((item: { phone: string }) => {
      if (!CheckPhoneNumberEmpty(item.phone)) {
        isValid = false;
      }
    });

    if (!data?.phones || data?.phones?.length === 0) {
      toastr.error("Error", "phone number required");
      return;
    }
    if (!isValid) {
      toastr.error("Error", "Each phone number should be valid");
      return;
    }

    const updateData: UpdateCompanyData = {
      name: props.details?.name,
      cinNumber: props.details?.cinNumber,
      fan: props.details?.fan,
      sector: props.details?.sector?._id,
      industry: props.details?.industry?._id,
      companySegment: props.details?.companySegment?._id,
      // salesType: props.details?.salesType?._id,
      addresses: props.details?.addresses,
      phones: data?.phones,
    };
    try {
      const response = await api.company.updateCompnay(
        updateData,
        props.details?._id
      );

      props.updateCompany(response);
      props.onClose();
      toastr.success("Success", "Phone number saved successfully");
    } catch (error) {
      if (error?.response?.data?.data?.message) {
        toastr.error("Error", error?.response?.data?.data?.message.join());
      } else {
        toastr.error("Error", error?.response?.data?.message);
      }
    }
  };

  const onUpdate = async (phones: Phone[]) => {
    const updateData: UpdateCompanyData = {
      name: props.details?.name,
      cinNumber: props.details?.cinNumber,
      fan: props.details?.fan,
      sector: props.details?.sector?._id,
      industry: props.details?.industry?._id,
      companySegment: props.details?.companySegment?._id,
      // salesType: props.details?.salesType?._id,
      addresses: props.details?.addresses,
      phones,
    };
    const response = await api.company.updateCompnay(
      updateData,
      props.details?._id
    );

    props.updateCompany(response);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="d-flex flex-wrap px-4 py-1 contact-form-row active border-top border-bottom">
        <div className="col pl-0 pr-2 contact-label font-xs text-gray-500 pt-2">
          Phone<span className="text-danger">*</span>
        </div>
        <div className="col pl-2 pr-0 contact-content d-flex align-items-center flex-wrap">
          <Controller
            control={control}
            rules={{
              required: true,
              validate: (value) => {
                return ValidatePhoneNumberArray(value);
              },
            }}
            name="phones"
            defaultValue={props.details?.phones}
            render={({ onChange, value }) => (
              <CustomerPhone
                className="form-control p-0 rounded-sm font-weight-semibold"
                placeholder="Phone"
                value={value}
                onChange={onChange}
                isEdit
                onUpdate={onUpdate}
              />
            )}
          />
          {errors.phones && (
            <div className="w-100">
              <ErrorMessage>
                {(errors.phones as any)?.type === "required"
                  ? "Mobile Number is required"
                  : "Invalid Mobile Number"}
              </ErrorMessage>
            </div>
          )}
        </div>
        <div className="col-12 pl-2 pr-0 mt-1 text-right">
          <button
            className="btn btn-sm btn-outline-dark mr-2 font-normal"
            onClick={props.onClose}
          >
            Cancel
          </button>
          <button className="btn btn-sm btn-primary font-normal">Save</button>
        </div>{" "}
      </div>
    </form>
  );
};

export default EditCompanyPhone;
